import { render } from "./PlotLegend.vue?vue&type=template&id=24653ae4"
import script from "./PlotLegend.vue?vue&type=script&lang=js"
export * from "./PlotLegend.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__